import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';

import { Sidebar, Topbar, Footer } from './components';
import { getCurrentLocale, LOCALE_CHANGED_EVENT } from '../../i18n';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64,
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%',
    paddingBottom: '5rem',
    overflow:'auto'
  },
  footer: {
    position: 'absolute',
    paddingBottom: '1rem',
    bottom: 0,
    width: '100%',
    height: '5rem'            /* Footer height */
  }

}));

const Main = props => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);
  const [localeVersion, setLocaleVersion] = useState(()=> getCurrentLocale());

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };
  const handleClick=()=>{
    setOpenSidebar(false);
  }

  useEffect(()=>{
    if (typeof window === 'undefined') {
      return undefined;
    }
    const handleLocaleChange = (event)=>{
      setLocaleVersion(event?.detail?.locale || getCurrentLocale());
    };
    window.addEventListener(LOCALE_CHANGED_EVENT, handleLocaleChange);
    return ()=>{
      window.removeEventListener(LOCALE_CHANGED_EVENT, handleLocaleChange);
    };
  }, []);

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}
    >
      <Topbar onSidebarOpen={handleSidebarOpen} />
      <Sidebar
        handleClick={handleClick}
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
      />
      <main className={classes.content}>
        <React.Fragment key={localeVersion}>
          {children}
        </React.Fragment>

        <Footer className={ classes.footer} />
       
      </main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
